import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
export function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      // Jump instantly to the element (no smooth scroll)
      requestAnimationFrame(() => {
        const el = document.getElementById(hash.replace('#', ''));
        if (el) {
          el.scrollIntoView({
            behavior: 'auto',
            block: 'start'
          });
        }
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}